import { useQuery } from "react-query";
import { GET_TELEHEALTH_PREREQUISITES, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getTelehealthPrerequisites } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

const useGetTelehealthPrerequisites = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_TELEHEALTH_PREREQUISITES, clientId],
    () => getTelehealthPrerequisites(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords(data);
  const telehealthPrerequisites = records.length > 0 ? records[0] : null;

  return {
    telehealthPrerequisites,
    telehealthPrerequisitesLoading: isLoading,
    refetchTelehealthPrerequisites: refetch,
    ...rest,
  };
};

export default useGetTelehealthPrerequisites;
